'use client'

import { LucideIcon } from 'lucide-react'
import { useI18n } from '@/components/providers/I18nProvider'

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description: string
  action?: React.ReactNode
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  const { t } = useI18n()
  const titleContent = t(title)
  const descriptionContent = t(description)

  return (
    <div className="text-center py-12">
      <Icon className="h-12 w-12 mx-auto text-muted-foreground/60 mb-4" />
      <h3 className="text-lg font-medium text-foreground mb-2">{titleContent}</h3>
      <p className="text-muted-foreground mb-4">{descriptionContent}</p>
      {action}
    </div>
  )
}
